import { IconProps } from "../types/icon";

export const StarIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      {...props}
    >
      <path
        fill={color}
        d="m11.572 4.27-3.54-.514L6.448.548a.52.52 0 0 0-.9 0l-1.58 3.208-3.54.514a.5.5 0 0 0-.277.853l2.562 2.5-.606 3.526a.5.5 0 0 0 .726.527L6 10.008l3.167 1.665a.5.5 0 0 0 .726-.527L9.287 7.62l2.562-2.5a.5.5 0 0 0-.277-.853z"
      />
    </svg>
  );
};
